var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconOpportunity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.498,
    height: 65.498,
    viewBox: "0 0 65.498 65.498",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bulb",
    transform: "translate(-22 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11694",
    "data-name": "Path 11694",
    d: "M24,54.749h3.417M54.749,24v3.417M82.082,54.749H85.5M32.883,32.883l2.392,2.392m41.341-2.392-2.392,2.392",
    transform: "translate(-24 -24)",
    fill: "none",
    stroke: "#f69139",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11695",
    "data-name": "Path 11695",
    d: "M62.832,86.749a17.083,17.083,0,1,1,20.5,0A11.958,11.958,0,0,0,79.915,97a6.833,6.833,0,1,1-13.666,0,11.958,11.958,0,0,0-3.417-10.25",
    transform: "translate(-42.332 -42.334)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11696",
    "data-name": "Path 11696",
    d: "M77.6,136H93.316",
    transform: "translate(-54.709 -88.168)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOpportunity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-opportunity.1cd83e91.svg";
export { ForwardRef as ReactComponent };